// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/" + chunkId + "." + chunkId + "." + {"2589":"d58c8f4e","4718":"871a0e94","4954":"fd33d5f1","6449":"09930c65","9103":"b9ea4917"}[chunkId] + ".css";
};